export const API_GET_REQUEST = "API_GET_REQUEST";
export const API_SET_RESPONSE = "API_SET_RESPONSE";

export const API = "API";
export const API_START = "API_START";
export const API_END = "API_END";
export const API_ACCESS_DENIED = "API_ACCESS_DENIED";
export const API_ERROR = "API_ERROR";
